import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    signUp: en,
  },
  fr: {
    signUp: fr,
  },
  pt: {
    signUp: pt,
  },
};
